import { subscribe } from '../../common/errors/sagas';
import { notificationError } from '../../common/errors/notificationTypes';

const pre = 'STATICDATAMAPPINGS/';

export const SET_COMMODITY_MAPPING_ROWS = `${pre}SET_COMMODITY_MAPPING_ROWS`;
export const SET_ISDA_CURVE_ROWS = `${pre}SET_ISDA_CURVE_ROWS`;
export const SET_ICE_ISIN_ROWS = `${pre}SET_ICE_ISIN_ROWS`;
export const SET_EQUITY_SEDOL_ROWS = `${pre}SET_EQUITY_SEDOL_ROWS`;
export const SET_PRODUCT_CLASS_ROWS = `${pre}SET_PRODUCT_CLASS_ROWS`;
export const SET_CURRENCY_MAPPING_ROWS = `${pre}SET_CURRENCY_MAPPING_ROWS`;
export const STATIC_DATA_MAPPINGS_LOADED = `${pre}STATIC_DATA_MAPPINGS_LOADED`;
export const FETCH_STATIC_DATA_FAILED = `${pre}FETCH_STATIC_DATA_FAILED`;

export const SET_COMMODITY_LOADING = `${pre}SET_COMMODITY_LOADING`;
export const SET_EQUITY_CREDIT_LOADING = `${pre}SET_EQUITY_CREDIT_LOADING`;
export const SET_EQUITY_MAPPING_LOADING = `${pre}SET_EQUITY_MAPPING_LOADING`;
export const SET_ISDA_LOADING = `${pre}SET_ISDA_LOADING`;
export const SET_PRODUCT_CLASS_LOADING = `${pre}SET_PRODUCT_CLASS_LOADING`;
export const SET_CURRENCY_MAPPING_LOADING = `${pre}SET_CURRENCY_MAPPING_LOADING`;

export const SET_ISDA_MAPPING_DROPDOWN_OPTIONS = `${pre}SET_ISDA_MAPPING_DROPDOWN_OPTIONS`;
export const SET_COMMODITY_MAPPING_DROPDOWN_OPTIONS = `${pre}SET_COMMODITY_MAPPING_DROPDOWN_OPTIONS`;
export const SET_PRODUCT_CLASS_DROPDOWN_OPTIONS = `${pre}SET_PRODUCT_CLASS_DROPDOWN_OPTIONS`;
export const SET_CURRENCY_DROPDOWN_OPTIONS = `${pre}SET_CURRENCY_DROPDOWN_OPTIONS`;

export const CREATE_STATIC_DATA_MAPPING_FAILED = `${pre}CREATE_STATIC_DATA_MAPPING_FAILED`;
export const FETCH_DROPDOWN_VALUES_FAILED = `${pre}FETCH_DROPDOWN_VALUES_FAILED`;

export const SET_FETCHED_ISDA_MAPPING_OPTIONS = `${pre}SET_FETCHED_ISDA_MAPPING_OPTIONS`;
export const SET_FETCHED_COMMODITY_MAPPING_OPTIONS = `${pre}SET_FETCHED_COMMODITY_MAPPING_OPTIONS`;
export const SET_FETCHED_PRODUCT_CLASS_OPTIONS = `${pre}SET_FETCHED_PRODUCT_CLASS_OPTIONS`;
export const SET_FETCHED_CURRENCY_OPTIONS = `${pre}SET_FETCHED_CURRENCY_OPTIONS`;

export const SET_ALL_GRIDS_LOADING = `${pre}SET_ALL_GRIDS_LOADING`;

export const FETCH_DROPDOWN_OPTIONS = `${pre}FETCH_DROPDOWN_OPTIONS`;
export const CREATE_NEW_MAPPING = `${pre}CREATE_NEW_MAPPING`;

export const DELETE_MAPPING = `${pre}DELETE_MAPPING`;
export const DELETE_MAPPING_FAILED = `${pre}DELETE_MAPPING_FAILED`;

export const CREATE_ISDA_ROW = `${pre}CREATE_ISDA_ROW`;
export const CREATE_COMMODITY_ROW = `${pre}CREATE_COMMODITY_ROW`;
export const CREATE_EQUITY_ROW = `${pre}CREATE_EQUITY_ROW`;
export const CREATE_CURRENCY_MAPPING_ROW = `${pre}CREATE_CURRENCY_MAPPING_ROW`;

export const DELETE_ISDA_ROW = `${pre}DELETE_ISDA_ROW`;
export const DELETE_COMMODITY_ROW = `${pre}DELETE_COMMODITY_ROW`;
export const DELETE_EQUITY_ROW = `${pre}DELETE_EQUITY_ROW`;
export const DELETE_CURRENCY_MAPPING_ROW = `${pre}DELETE_CURRENCY_MAPPING_ROW`;

export const EDIT_ISDA_ROW = `${pre}EDIT_ISDA_ROW`;
export const EDIT_COMMODITY_ROW = `${pre}EDIT_COMMODITY_ROW`;
export const EDIT_EQUITY_ROW = `${pre}EDIT_EQUITY_ROW`;
export const EDIT_PRODUCT_CLASS_ROW = `${pre}EDIT_PRODUCT_CLASS_ROW`;
export const EDIT_CURRENCY_MAPPING_ROW = `${pre}EDIT_CURRENCY_MAPPING_ROW`;

export const EDIT_MAPPING = `${pre}EDIT_MAPPING`;
export const EDIT_MAPPING_FAILED = `${pre}EDIT_MAPPING_FAILED`;

export const SET_GRID_SORTS = `${pre}SET_GRID_SORTS`;
export const SET_ALL_GRID_SORTS = `${pre}SET_ALL_GRID_SORTS`;

subscribe(FETCH_STATIC_DATA_FAILED, 'Failed to load static data', notificationError);
subscribe(CREATE_STATIC_DATA_MAPPING_FAILED, 'Failed to create a new mapping', notificationError);
subscribe(FETCH_DROPDOWN_VALUES_FAILED, 'Failed to fetch dropdown values', notificationError);
subscribe(DELETE_MAPPING_FAILED, 'Failed to delete row', notificationError);

export const createEquityRow = (id, value, key) => ({
    type: CREATE_EQUITY_ROW,
    id,
    value,
    key
});

export const createCommodityRow = (id, value, key) => ({
    type: CREATE_COMMODITY_ROW,
    id,
    value,
    key
});

export const createIsdaRow = (id, value, key) => ({
    type: CREATE_ISDA_ROW,
    id,
    value,
    key
});

export const createCurrencyMappingRow = (id, value, key) => ({
    type: CREATE_CURRENCY_MAPPING_ROW,
    id,
    value,
    key
});


export const setAllGridSorts = data => ({
    type: SET_ALL_GRID_SORTS,
    data
});

export const setGridSorts = (gridId, sorting) => ({
    type: SET_GRID_SORTS,
    gridId,
    sorting
});

export const editEquityRow = (id, key, value) => ({
    type: EDIT_EQUITY_ROW,
    id,
    key,
    value
});

export const editCommodityRow = (id, key, value) => ({
    type: EDIT_COMMODITY_ROW,
    id,
    key,
    value
});

export const editIsdaRow = (id, key, value) => ({
    type: EDIT_ISDA_ROW,
    id,
    key,
    value
});

export const editProductClassRow = (id, key, value) => ({
    type: EDIT_PRODUCT_CLASS_ROW,
    id,
    key,
    value
});

export const editCurrencyMappingRow = (id, key, value) => ({
    type: EDIT_CURRENCY_MAPPING_ROW,
    id,
    key,
    value
});

export const deleteEquityRow = id => ({
    type: DELETE_EQUITY_ROW,
    id
});

export const deleteCurrencyRow = id => ({
    type: DELETE_CURRENCY_MAPPING_ROW,
    id
});

export const deleteCommodityRow = id => ({
    type: DELETE_COMMODITY_ROW,
    id
});

export const deleteIsdaRow = id => ({
    type: DELETE_ISDA_ROW,
    id
});

export const deleteMappingFailed = error => ({
    type: DELETE_MAPPING_FAILED,
    error
});

export const editMappingFailed = error => ({
    type: EDIT_MAPPING_FAILED,
    error
});

export const editMapping = mapping => (id, key, value) => ({
    type: EDIT_MAPPING,
    mapping,
    id,
    key,
    value
});

export const deleteMapping = mapping => id => ({
    type: DELETE_MAPPING,
    mapping,
    id
});

export const createNewMapping = mapping => (key, value) => ({
    type: CREATE_NEW_MAPPING,
    key,
    value,
    mapping
});

export const fetchDropdownOptions = mapping => () => ({
    type: FETCH_DROPDOWN_OPTIONS,
    mapping
});

export const setFetchedIsdaMappingOptions = fetched => ({
    type: SET_FETCHED_ISDA_MAPPING_OPTIONS,
    fetched
});

export const setFetchedCommodityMappingOptions = fetched => ({
    type: SET_FETCHED_COMMODITY_MAPPING_OPTIONS,
    fetched
});

export const setFetchedProductClassOptions = fetched => ({
    type: SET_FETCHED_PRODUCT_CLASS_OPTIONS,
    fetched
});

export const setFetchedCurrencyOptions = fetched => ({
    type: SET_FETCHED_CURRENCY_OPTIONS,
    fetched
});

export const fetchDropdownOptionsFailed = error => ({
    type: FETCH_DROPDOWN_VALUES_FAILED,
    error
});

export const setIsdaMappingDropdownOptions = options => ({
    type: SET_ISDA_MAPPING_DROPDOWN_OPTIONS,
    options
});

export const setCommodityMappingOptions = options => ({
    type: SET_COMMODITY_MAPPING_DROPDOWN_OPTIONS,
    options
});

export const setProductClassOptions = options => ({
    type: SET_PRODUCT_CLASS_DROPDOWN_OPTIONS,
    options
});

export const setCurrencyOptions = options => ({
    type: SET_CURRENCY_DROPDOWN_OPTIONS,
    options
});


export const createStaticDataMappingFailed = error => ({
    type: CREATE_STATIC_DATA_MAPPING_FAILED,
    error
});

export const setCommodityLoading = loading => ({
    type: SET_COMMODITY_LOADING,
    loading
});

export const setEquityCreditLoading = loading => ({
    type: SET_EQUITY_CREDIT_LOADING,
    loading
});

export const setEquityMappingLoading = loading => ({
    type: SET_EQUITY_MAPPING_LOADING,
    loading
});

export const setIsdaLoading = loading => ({
    type: SET_ISDA_LOADING,
    loading
});

export const setProductClassLoading = loading => ({
    type: SET_PRODUCT_CLASS_LOADING,
    loading
});

export const setCurrencyMappingLoading = loading => ({
    type: SET_CURRENCY_MAPPING_LOADING,
    loading
});

export const staticDataMappingsLoaded = () => ({
    type: STATIC_DATA_MAPPINGS_LOADED
});

export const setCommodityMappingRows = data => ({
    type: SET_COMMODITY_MAPPING_ROWS,
    data
});

export const setIsdaCurveRows = data => ({
    type: SET_ISDA_CURVE_ROWS,
    data
});

export const setIceIsinRows = data => ({
    type: SET_ICE_ISIN_ROWS,
    data
});

export const setEquitySedolRows = data => ({
    type: SET_EQUITY_SEDOL_ROWS,
    data
});

export const setProductClassRows = data => ({
    type: SET_PRODUCT_CLASS_ROWS,
    data
});

export const setCurrencyMappingRows = data => ({
    type: SET_CURRENCY_MAPPING_ROWS,
    data
});

export const fetchStaticDataFailed = error => ({
    type: FETCH_STATIC_DATA_FAILED,
    error
});

export const setAllGridsLoading = loading => ({
    type: SET_ALL_GRIDS_LOADING,
    loading
});
